"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/helpers/defineProperty.js
 ** module id = 1039
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/helpers/defineProperty.js
 ** module id = 1039
 ** module chunks = 1
 **/